export default "__VITE_ASSET__CHCYPX6I__"